
import React from 'react';

const FooterCTA = () => {
  return (
    <div className="mt-8 md:mt-0 flex items-center">
      <a href="https://www.g2.com/products/cutshort/reviews" target="_blank" rel="noopener noreferrer" className="mr-4">
        <img 
          src="/lovable-uploads/8350a596-464a-42ea-8d9e-9192bc3b68c0.png" 
          alt="G2 Reviews" 
          className="h-12 w-auto object-contain"
        />
      </a>
      <div className="flex items-center">
        <a 
          href="https://saasboomi.org/initiatives/sgx/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center"
        >
          <img 
            src="/lovable-uploads/f7ea5d5f-2169-4ad1-af4c-2e6fa71e404a.png" 
            alt="SaasBoomi" 
            className="h-8 w-auto object-contain mr-2"
          />
          <span className="text-brand-grey">SGx Cohort 2</span>
        </a>
      </div>
    </div>
  );
};

export default FooterCTA;
